import {
  LandingHugePackElements,
  LandingHugePackElementsProps
} from '../../../../components/_external-pages/landing';
import { Box, Container, Stack, Typography } from '@mui/material';
import { Decorator2, Decorator3, Decorator1, Decorator4 } from './HomeDecorators';
import { styled } from '@mui/material/styles';
import { MotionViewFadeUp } from '../../../../components/MotionViewFadeUp';

const array: LandingHugePackElementsProps[] = [
  {
    img: '/static/artesano1shadow.webp',
    smallTitle: 'Crédito',
    title: 'Solución',
    subTitle: 'Ideal para consolidar deudas, remodelación e inversión en tu negocio.',
    subTitleBold: 'Obtén desde $100 mil hasta $100 millones.',
    position: 'left',
    decorator: Decorator1,
    buttons: [
      {
        text: 'Conocer más',
        variant: 'contained',
        color: 'primary',
        size: 'medium',
        href: '',
        to: '/productos/credito-solucion'
      },
      {
        text: 'Simular crédito',
        variant: 'outlined',
        color: 'primary',
        size: 'medium',
        href: '',
        to: '/simulador'
      }
    ]
  },
  {
    img: '/static/artesano2shadow.webp',
    smallTitle: 'Crédito',
    title: 'Comercial',
    subTitle: 'Fortalece tu negocio y reduce tus costos financieros.',
    subTitleBold: 'Obtén desde $100 mil hasta $100 millones.',
    position: 'right',
    decorator: Decorator2,
    buttons: [
      {
        text: 'Conocer más',
        variant: 'contained',
        color: 'primary',
        size: 'medium',
        href: '',
        to: '/productos/credito-comercial'
      },
      {
        text: 'Simular crédito',
        variant: 'outlined',
        color: 'primary',
        size: 'medium',
        href: '',
        to: '/simulador'
      }
    ]
  },
  {
    img: '/static/artesano3shadow.webp',
    smallTitle: 'Crédito',
    title: 'Construcción',
    subTitle: 'Concluye tu proyecto inmobiliario, civil o comercial.',
    subTitleBold: 'Obtén desde $1 millón hasta $50 millones.',
    position: 'left',
    decorator: Decorator3,
    buttons: [
      {
        text: 'Conocer más',
        variant: 'contained',
        color: 'primary',
        size: 'medium',
        href: '',
        to: '/productos/credito-construccion'
      },
      {
        text: 'Simular crédito',
        variant: 'outlined',
        color: 'primary',
        size: 'medium',
        href: '',
        to: '/simulador'
      }
    ]
  },
  {
    img: '/static/artesano4shadow.webp',
    smallTitle: 'Crédito',
    title: 'Mejora tu cuota',
    subTitle: 'Incrementa tu monto, baja la tasa o sube el plazo a pagar.',
    subTitleBold: 'Reduce hasta un 10% de tu cuota actual.',
    position: 'right',
    decorator: Decorator4,
    buttons: [
      {
        text: 'Conocer más',
        variant: 'contained',
        color: 'primary',
        size: 'medium',
        href: '',
        to: '/productos/mejora-tu-cuota'
      },
      {
        text: 'Simular crédito',
        variant: 'outlined',
        color: 'primary',
        size: 'medium',
        href: '',
        to: '/simulador'
      }
    ]
  }
];
const title = 'Créditos pensados exclusivamente para ti';
const RootStyle = styled('div')(({ theme }) => ({}));

export const HomeImgTextCollection = () => {
  return (
    <RootStyle>
      <Stack spacing={1}>
        <Container maxWidth={'lg'}>
          <MotionViewFadeUp>
            <Typography
              sx={{
                display: {
                  xl: 'block',
                  lg: 'block',
                  md: 'block',
                  sm: 'none',
                  xs: 'none'
                }
              }}
              align={'center'}
              variant={'h2'}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                display: {
                  xl: 'none',
                  lg: 'none',
                  md: 'none',
                  sm: 'block',
                  xs: 'block'
                }
              }}
              align={'center'}
              variant={'h4'}
            >
              {title}
            </Typography>
          </MotionViewFadeUp>

          <Box sx={{ margin: '5em 0' }} />
        </Container>

        <MotionViewFadeUp>
          <LandingHugePackElements {...array[0]} />
        </MotionViewFadeUp>
        <MotionViewFadeUp>
          <LandingHugePackElements {...array[1]} />
        </MotionViewFadeUp>
        <MotionViewFadeUp>
          <LandingHugePackElements {...array[2]} />
        </MotionViewFadeUp>
        <MotionViewFadeUp>
          <LandingHugePackElements {...array[3]} />
        </MotionViewFadeUp>
      </Stack>
    </RootStyle>
  );
};
